// قالب‌های حرکت — منبعِ واحدِ حقیقت برای فرمِ پویا (هر نوع حرکت فقط فیلدهای خودش)
// fixedSourceType/fixedDestType = طرفِ ثابت که سروری ست می‌شود و در UI فقط برچسب نشان داده می‌شود.
// جریانِ ساده‌شده (۳ مرحله): خرید نخ از درین → خروجی بافندگی (خودکار به پوشان) → خروجی پوشان (خودکار به انبار قرچک).
// فی/قیمت اختیاری است. حداقلِ فیلدهای الزامی؛ بقیه بعداً تکمیل می‌شود (نیازمندِ تکمیل).

export const MOVEMENT_TEMPLATES = {
  yarn_purchased: {
    label: "خرید نخ",
    unit: "yarn",
    // تأمین‌کننده قابلِ انتخاب (درین یا هر شرکتِ دیگر)؛ خالی = پیش‌فرض (قدیمی‌ترین تأمین‌کنندهٔ فعال)
    sourceSelect: { name: "source_party_id", label: "تأمین‌کنندهٔ نخ", types: ["supplier"], defaultHint: true },
    // بافندهٔ مقصد اجباری: نخ مستقیم به موجودیِ همان بافنده وارد می‌شود (محل اولیهٔ نخ حذف شد)
    destSelect: { name: "destination_party_id", label: "بافندهٔ مقصد", types: ["knitting_workshop"] },
    required: ["event_date", "destination_party_id", "weight_kg"],
    main: ["destination_party_id", "item_type_id", "weight_kg"],
    advanced: ["carton_count", "pallet_count", "yarn_count", "twist"],
    docs: ["external_document_number", "permit_number", "notes"],
    accounting: ["unit_price", "total_amount"],
  },
  raw_fabric_sent_to_dyeing: {
    label: "خروجی بافندگی",   // خروجیِ بافنده = پارچهٔ خامی که خودکار واردِ پوشان می‌شود
    unit: "raw_fabric",
    sourceSelect: { name: "source_party_id", label: "بافنده", types: ["knitting_workshop"] },
    // یک ثبت = خروج از بافنده + ورود به رنگرزی؛ خالی = رنگرزیِ پیش‌فرض (پوشان)
    destSelect: { name: "destination_party_id", label: "رنگرزیِ مقصد", types: ["dyeing_provider"], defaultHint: true },
    required: ["event_date", "source_party_id", "weight_kg"],
    main: ["source_party_id", "fabric_type", "weight_kg"],
    advanced: ["roll_count"],
    docs: ["external_document_number", "notes"],   // شماره فاکتور
    accounting: ["unit_price", "total_amount"],     // فی خدمات / جمع خدمات
  },
  dyed_fabric_received_in_gharchak_warehouse: {
    label: "خروجی رنگرزی",   // خروجیِ رنگ‌شدهٔ رنگرزی = خودکار واردِ انبار (پیش‌فرض: پوشان → قرچک)
    unit: "dyed_fabric",
    sourceSelect: { name: "source_party_id", label: "رنگرزی", types: ["dyeing_provider"], defaultHint: true },
    destSelect: { name: "destination_party_id", label: "انبارِ مقصد", types: ["internal_warehouse"], defaultHint: true },
    required: ["event_date", "weight_kg"],
    main: ["fabric_type", "color", "weight_kg"],
    advanced: ["roll_count", "operation_code", "order_code"],
    docs: ["external_invoice_number", "external_document_number", "notes"],
    accounting: ["unit_price", "total_amount"],
  },
  adjustment: {
    label: "اصلاحیه",
    unit: "any",
    holderSelect: { name: "current_holder_party_id", label: "طرف‌حساب", types: null },
    required: ["event_date", "current_holder_party_id", "reason"],
    main: ["current_holder_party_id", "item_type_id", "weight_kg"],
    advanced: [],
    docs: ["reason", "notes"],
    accounting: [],
  },
  opening_balance: {
    label: "مانده اول دوره",
    unit: "any",
    holderSelect: { name: "destination_party_id", label: "نگه‌دارنده", types: null },
    required: ["event_date", "destination_party_id", "item_type_id", "weight_kg"],
    main: ["destination_party_id", "item_type_id", "weight_kg"],
    advanced: [],
    docs: ["reason", "notes"],
    accounting: [],
  },
  // ── انواعِ قدیمی: از منوی «ثبت حرکت جدید» مخفی‌اند ولی برای نمایش/ویرایشِ سوابق نگه داشته شده‌اند ──
  yarn_sent_to_knitter: {
    label: "ارسال نخ به بافندگی (قدیمی)",
    unit: "yarn",
    legacy: true,
    sourceFixedLabel: "از موجودیِ نخِ خریداری‌شده (درین)",
    destSelect: { name: "destination_party_id", label: "مقصد بافندگی", types: ["knitting_workshop"] },
    sourcePurchase: true,
    required: ["event_date", "destination_party_id", "weight_kg"],
    main: ["source_purchase_id", "destination_party_id", "item_type_id", "weight_kg"],
    advanced: ["carton_count", "pallet_count"],
    docs: ["external_document_number", "permit_number", "notes"],
    accounting: ["unit_price", "total_amount"],
  },
  raw_fabric_produced: {
    label: "تولید پارچهٔ خام نزد بافنده (قدیمی)",
    unit: "raw_fabric",
    legacy: true,
    holderSelect: { name: "current_holder_party_id", label: "بافندگی", types: ["knitting_workshop"] },
    required: ["event_date", "current_holder_party_id", "weight_kg"],
    main: ["current_holder_party_id", "fabric_type", "weight_kg"],
    advanced: ["roll_count", "yarn_count"],
    docs: ["external_document_number", "permit_number", "notes"],
    accounting: ["unit_price", "total_amount"],
  },
  dyed_fabric_received_from_dyeing: {
    label: "خروج رنگرزی از پوشان (قدیمی)",
    unit: "dyed_fabric",
    legacy: true,
    fixedSourceType: "dyeing_provider",
    showDestination: false,
    required: ["event_date", "fabric_type", "color", "weight_kg"],
    main: ["fabric_type", "color", "weight_kg"],
    advanced: ["roll_count", "operation_code", "order_code"],
    docs: ["external_document_number", "permit_number", "notes"],
    accounting: ["unit_price", "total_amount"],
  },
  waste_registered: {
    label: "ثبت ضایعات",
    unit: "any",
    legacy: true,
    holderSelect: { name: "current_holder_party_id", label: "نزد طرف‌حساب", types: null },
    required: ["event_date", "current_holder_party_id", "weight_kg"],
    main: ["current_holder_party_id", "item_type_id", "weight_kg"],
    advanced: [],
    docs: ["reason", "notes"],
    accounting: [],
  },
};

export const getTemplate = (et) => MOVEMENT_TEMPLATES[et] || MOVEMENT_TEMPLATES.adjustment;

// انواعِ اصلیِ قابل‌انتخاب در «ثبت حرکت جدید» (بقیه مخفی‌اند؛ سوابقِ قدیمی همچنان نمایش/ویرایش می‌شوند)
export const PRIMARY_MOVEMENT_TYPES = [
  { v: "yarn_purchased", l: "خرید نخ" },
  { v: "raw_fabric_sent_to_dyeing", l: "خروجی بافندگی" },
  { v: "dyed_fabric_received_in_gharchak_warehouse", l: "خروجی رنگرزی" },
  { v: "adjustment", l: "اصلاحیه" },
  { v: "opening_balance", l: "مانده اول دوره" },
];
export const PRIMARY_TYPE_VALUES = PRIMARY_MOVEMENT_TYPES.map((t) => t.v);

// فیلدهای واحد بر اساس نوعِ کالا (نمایشِ بافت‌محور)
export const UNIT_FIELDS = {
  yarn: ["carton_count", "yarn_count", "twist"],
  raw_fabric: ["roll_count", "fabric_type"],
  dyed_fabric: ["roll_count", "color", "operation_code"],
  any: ["roll_count", "carton_count"],
};

// راهنمای انتخاب نوع عملیات (جریانِ ۳مرحله‌ای)
export const MOVEMENT_GUIDE = [
  ["خرید نخ", "نخ از تأمین‌کنندهٔ انتخابی (پیش‌فرض درین) خریداری می‌شود و مستقیم به موجودیِ بافندهٔ انتخابی وارد می‌شود."],
  ["خروجی بافندگی", "مقدار پارچهٔ خامِ تولیدشدهٔ هر بافنده. خودکار به‌عنوان ورودیِ رنگرزیِ انتخابی (پیش‌فرض پوشان) حساب می‌شود."],
  ["خروجی رنگرزی", "مقدار پارچهٔ رنگ‌شدهٔ خروجیِ رنگرزی. خودکار واردِ انبار (پیش‌فرض قرچک) می‌شود."],
  ["شرکتِ جدید", "در هر فهرستِ انتخابِ طرف‌حساب، گزینهٔ «افزودنِ شرکتِ جدید» پایینِ فهرست است؛ یا از صفحهٔ «طرف‌حساب‌ها»."],
  ["اصلاحیه", "برای تصحیحِ دستیِ ماندهٔ یک طرف."],
];

// اقدام‌های سریعِ اصلی (۳ مرحله)
export const QUICK_ACTIONS = [
  "yarn_purchased", "raw_fabric_sent_to_dyeing", "dyed_fabric_received_in_gharchak_warehouse",
];
